export type SortDirection = 'desc' | 'asc';

export const flipDirection = (direction: SortDirection): SortDirection => {
  return direction === 'desc' ? 'asc' : 'desc';
};

export const dateFormat = 'MMM. d, yyyy';
export const timeFormat = 'h:mm a';
export const fullDateFormat = dateFormat + ' ' + timeFormat;
